/* eslint-disable react-hooks/exhaustive-deps */

import { useState, useCallback, useEffect } from "react";
import CloseIcon from '@mui/icons-material/Close';
import './ContactUsFlyout.scss';
import appSettings from '../../../src/appSettings';
import { useSelector } from 'react-redux';

const ContactUsFlyout =  ({toggleChatbot})  => {
    const [showFlyout, setShowFlyout] = useState(false);
    const [flyoutProps, setFlyoutProps] = useState({});
    const customLinks = useSelector(state=> state.customLinks);
    const SUPPORTLINK = 'SupportLink'; 
    const defaultProps = {
        ContactUsTitle: 'Customer service',
        ContactUsEmail: 'servicecenter@amig.com', 
        ContactUsPhone: '+1 (800) 543-2644',
        SupportChannelLink: appSettings.SUPPORT_CHANNEL_URL
    };

    const toggleFlyout = useCallback(() => {
        setShowFlyout(!showFlyout);
    }, [showFlyout]);

    const handleFlyouts = () => {
        toggleFlyout();
        toggleChatbot();
    };

    useEffect(() => {
        const contactLinks = (customLinks) ? customLinks.filter(function (link) {
            return link.category === SUPPORTLINK;
        }) : undefined;

        if (contactLinks === undefined || contactLinks.length === 0) {
            setFlyoutProps(defaultProps);
        } else {
            let contactUsDetails = {};
            contactLinks.forEach(elem => {
                contactUsDetails[elem.display] = elem.url;
            });
            setFlyoutProps(contactUsDetails);
        }
    }, [customLinks]);

    return (
        <>
            <div id="contact-us-container" className="sticky-fab-container">
                {showFlyout && <div id="contact-us-flyout" className="sticky-fab-flyout">
                    <div id="contact-us-header" className="contact-us-fab-flyout-header">
                        <div className="contact-us-flyout-icon">
                            <img className="desktop-flyout-icon" src={require('../../common/assets/img/contact-us-icon.png')} alt="Contact us" />
                            <img className="mobile-flyout-icon" src={require('../../common/assets/img/contact-us-purple.png')} alt="Contact us" />
                        </div>
                        <div className="fab-flyout-title">Contact American Modern</div>                        
                        <button className="close-contact-us-fab-flyout" onClick={toggleFlyout}>
                            <CloseIcon fontSize={'small'} />
                        </button>
                    </div>
                    <div id="contact-us-content" className="fab-flyout-content">
                        <div className="flyout-content-title">We're here for you</div>
                        <div className="flyout-content-subtitle">Need help now?</div>
                        <div className="flyout-content-text">You can get help starting a quote, assistance with existing policies, reset your password and more. Available Monday - Friday (8am - 8pm Eastern)</div>
                        <div className="live-chat-link" onClick={handleFlyouts} target="_blank" rel='noreferrer'>
                            <button className="live-chat-button">
                        <img src={require('../../common/assets/img/live-chat-small.png')} alt="Chat" />
                            Chat
                            </button></div>
                        <hr className="horizontal-line-block"/>
                        {flyoutProps.ContactUsTitle && <div className="flyout-content-subtitle">{flyoutProps.ContactUsTitle}</div>}
                        <div className="flyout-content-text">Our team is trained to help you solve problems. Mon - Fri (8am-8pm Eastern)</div>
                        {(flyoutProps.ContactUsPhone) && <div className="contact-us-link call-us">
                            <img className="desktop-flyout-icon" src={require('../../common/assets/img/call-us-gray.png')} alt="Call us" />
                            <img className="mobile-flyout-icon chatbot-mobile-icon" src={require('../../common/assets/img/contact-us-small.png')} alt="Call us" />
                            <a href={'tel:' + flyoutProps.ContactUsPhone}>{flyoutProps.ContactUsPhone}</a>
                        </div>}
                        {(flyoutProps.ContactUsEmail) && <div className="contact-us-link email-us">
                            <img className="desktop-flyout-icon" src={require('../../common/assets/img/email-us-purple.png')} alt="Email us" />
                            <img className="mobile-flyout-icon chatbot-mobile-icon" src={require('../../common/assets/img/envelope-icon.png')} alt="Email us" />
                            <a href={'mailto:' + flyoutProps.ContactUsEmail}>{flyoutProps.ContactUsEmail}</a>
                        </div>}
                        {flyoutProps.SupportChannelLink && <div className="support-channels">
                            <div className="flyout-content-text action-title">Don't see what you need?</div>
                            <a href={flyoutProps.SupportChannelLink} target="_blank" rel='noreferrer'>View all support channels</a>
                        </div>}
                    </div>
                </div>}
                {!showFlyout && <button id="contact-us" className="contact-us-sticky-fab" onClick={toggleFlyout}>
                    <img src={require('../../common/assets/img/contact-us-icon.png')} alt="Contact us" />
                </button>}
            </div>

        </>
    );
};
export default ContactUsFlyout;
